module.exports = __webpack_public_path__ + "static/Inserat2024AbacusHRConsultant-8d1e889fa56951a0e24594e3e5cd8577.pdf";